import { useGet } from './useApi';
import { useContextValue } from '../Context';

/**
 * Hook to check if the logged-in user's account has a financial hold
 */
export const useGetFinancialHold = () => {
  const { state } = useContextValue();

  return useGet<{ hasFinancialHold: boolean }>('/v1/auth/reg/financial-hold', {
    enabled: !!state.user?.id,
    refetchInterval: false,
  });
};
